import axios, { type AxiosError, type AxiosResponse } from 'axios'
import { useAuthStore } from '@/store/auth'
import { useSnackbarStore } from '@/store/snackbar'
import router from '@/router'

export const API_PREFIX = import.meta.env.VITE_API_PREFIX || '/v1'

const http = axios.create({
  baseURL: (import.meta.env.VITE_API_BASE_URL || '') + '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
})

// Attach bearer token to every request.
http.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Global error handling: logout + redirect on 401, normalize errors.
http.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error.response?.status
    if (status === 401 && router.currentRoute.value.name !== 'login') {
      const auth = useAuthStore()
      auth.logout()
      useSnackbarStore().info('Session expired. Please sign in again.')
      router.push({ name: 'login' })
    }
    const detail = (error.response?.data as { detail?: string })?.detail
    return Promise.reject({
      message: detail || error.message || 'An unexpected error occurred',
      status,
      data: error.response?.data,
    })
  },
)

export default http
